// This file was automatically generated by graphql-code-generator
// Changes to this file will be lost


import * as Types from '../../../engine/apis/magento2/types.generated.d';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetReviewsQueryVariables = Types.Exact<{
  sku: Types.Scalars['String'];
}>;


export type GetReviewsQuery = { __typename?: 'Query', products?: { __typename?: 'Products', items?: Array<{ __typename?: 'BundleProduct', sku?: string | null, rating_summary: number, review_count: number, reviews: { __typename?: 'ProductReviews', items: Array<{ __typename?: 'ProductReview', average_rating: number, created_at: string, nickname: string, summary: string, text: string, ratings_breakdown: Array<{ __typename?: 'ProductReviewRating', name: string, value: string } | null> } | null>, page_info: { __typename?: 'SearchResultPageInfo', current_page?: number | null, page_size?: number | null, total_pages?: number | null } } } | { __typename?: 'ConfigurableProduct', sku?: string | null, rating_summary: number, review_count: number, reviews: { __typename?: 'ProductReviews', items: Array<{ __typename?: 'ProductReview', average_rating: number, created_at: string, nickname: string, summary: string, text: string, ratings_breakdown: Array<{ __typename?: 'ProductReviewRating', name: string, value: string } | null> } | null>, page_info: { __typename?: 'SearchResultPageInfo', current_page?: number | null, page_size?: number | null, total_pages?: number | null } } } | { __typename?: 'DownloadableProduct', sku?: string | null, rating_summary: number, review_count: number, reviews: { __typename?: 'ProductReviews', items: Array<{ __typename?: 'ProductReview', average_rating: number, created_at: string, nickname: string, summary: string, text: string, ratings_breakdown: Array<{ __typename?: 'ProductReviewRating', name: string, value: string } | null> } | null>, page_info: { __typename?: 'SearchResultPageInfo', current_page?: number | null, page_size?: number | null, total_pages?: number | null } } } | { __typename?: 'GroupedProduct', sku?: string | null, rating_summary: number, review_count: number, reviews: { __typename?: 'ProductReviews', items: Array<{ __typename?: 'ProductReview', average_rating: number, created_at: string, nickname: string, summary: string, text: string, ratings_breakdown: Array<{ __typename?: 'ProductReviewRating', name: string, value: string } | null> } | null>, page_info: { __typename?: 'SearchResultPageInfo', current_page?: number | null, page_size?: number | null, total_pages?: number | null } } } | { __typename?: 'SimpleProduct', sku?: string | null, rating_summary: number, review_count: number, reviews: { __typename?: 'ProductReviews', items: Array<{ __typename?: 'ProductReview', average_rating: number, created_at: string, nickname: string, summary: string, text: string, ratings_breakdown: Array<{ __typename?: 'ProductReviewRating', name: string, value: string } | null> } | null>, page_info: { __typename?: 'SearchResultPageInfo', current_page?: number | null, page_size?: number | null, total_pages?: number | null } } } | { __typename?: 'VirtualProduct', sku?: string | null, rating_summary: number, review_count: number, reviews: { __typename?: 'ProductReviews', items: Array<{ __typename?: 'ProductReview', average_rating: number, created_at: string, nickname: string, summary: string, text: string, ratings_breakdown: Array<{ __typename?: 'ProductReviewRating', name: string, value: string } | null> } | null>, page_info: { __typename?: 'SearchResultPageInfo', current_page?: number | null, page_size?: number | null, total_pages?: number | null } } } | null> | null } | null };


export const GetReviewsDocument = gql`
    query getReviews($sku: String!) {
  products(filter: {sku: {eq: $sku}}, pageSize: 5) {
    items {
      sku
      rating_summary
      review_count
      reviews(pageSize: 500) {
        items {
          average_rating
          created_at
          nickname
          ratings_breakdown {
            name
            value
          }
          summary
          text
        }
        page_info {
          current_page
          page_size
          total_pages
        }
      }
    }
  }
}
    `;

/**
 * __useGetReviewsQuery__
 *
 * To run a query within a React component, call `useGetReviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReviewsQuery({
 *   variables: {
 *      sku: // value for 'sku'
 *   },
 * });
 */
export function useGetReviewsQuery(baseOptions: Apollo.QueryHookOptions<GetReviewsQuery, GetReviewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReviewsQuery, GetReviewsQueryVariables>(GetReviewsDocument, options);
      }
export function useGetReviewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReviewsQuery, GetReviewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReviewsQuery, GetReviewsQueryVariables>(GetReviewsDocument, options);
        }
export type GetReviewsQueryHookResult = ReturnType<typeof useGetReviewsQuery>;
export type GetReviewsLazyQueryHookResult = ReturnType<typeof useGetReviewsLazyQuery>;
export type GetReviewsQueryResult = Apollo.QueryResult<GetReviewsQuery, GetReviewsQueryVariables>;